// extracted by mini-css-extract-plugin
export default {"list":"ReasonsBlock_list__bY0BA","reason":"ReasonsBlock_reason__etARV","reasonIcon":"ReasonsBlock_reasonIcon__0obGt"};